<a [routerLink]="['/']">
  <img class="logo d-block" src="/assets/images/logo-beta.svg" alt="Spocaboo Logo Beta">
</a>
